/**
 * Cronologie — pagină dedicată cu feed WhatsApp-like pentru toate activitățile.
 * Filtre pe tab-uri: Toate / Inventar / PSA / Ore / Combustibil.
 * Scroll infinit (IntersectionObserver) — vezi ActivityFeed.jsx.
 */
import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ActivityFeed from "../components/ActivityFeed";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { MessageSquare } from "lucide-react";

const TABS = [
  { value: "all", label: "Toate", icon: "🌐" },
  { value: "inventory", label: "Inventar", icon: "📦" },
  { value: "psa", label: "PSA", icon: "🦺" },
  { value: "hours", label: "Ore", icon: "⏰" },
  { value: "fuel", label: "Combustibil", icon: "⛽" },
  { value: "damages", label: "Daune", icon: "⚠️" },
  { value: "repairs", label: "Reparații", icon: "🔧" },
  { value: "tools", label: "Scule", icon: "🎨" },
];

export default function Cronologie() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialCat = searchParams.get("category") || "all";
  const [category, setCategory] = useState(initialCat);

  useEffect(() => {
    // Sync URL cu tab-ul activ pentru deep-linking
    const cur = searchParams.get("category") || "all";
    if (cur !== category) {
      const next = new URLSearchParams(searchParams);
      if (category === "all") next.delete("category");
      else next.set("category", category);
      setSearchParams(next, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  return (
    <div className="max-w-4xl mx-auto pb-16" data-testid="cronologie-page">
      <div className="flex items-center gap-3 mb-6">
        <div className="bg-gradient-to-br from-emerald-500 to-teal-600 text-white rounded-xl p-2.5 shadow">
          <MessageSquare size={22}/>
        </div>
        <div>
          <h1 className="font-display text-3xl font-bold">Cronologie activitate</h1>
          <p className="text-sm text-zinc-500">
            Cine • Când • Pentru cine • Ce — flux ordonat cronologic pe toate modulele
          </p>
        </div>
      </div>

      <Tabs value={category} onValueChange={setCategory} className="mb-6">
        <TabsList className="grid grid-cols-4 md:grid-cols-8 w-full" data-testid="cronologie-tabs">
          {TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value} data-testid={`tab-${t.value}`}>
              <span className="mr-1">{t.icon}</span> {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <ActivityFeed category={category} pageSize={30}/>
    </div>
  );
}
